var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.showing)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"position-relative d-flex flex-center"},[_c('socket')],1)]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }